import { FONT_PAIRS } from '@/image-generator/presets';

/*
 * Fontes disponíveis no gerador. Vêm do Google Fonts (como a Poppins do
 * style.css) e são pré-carregadas com o ShareModal. Cada uma cobre um
 * papel: impacto (Anton, Archivo Black), revista (DM Serif, Fraunces),
 * moderno (Bricolage), apoio condensado (Barlow Condensed) e a marca (Poppins).
 */
export const FONTS = [
  { family: 'Poppins', weights: [400, 500, 600, 700, 800, 900], italic: true },
  { family: 'Anton', weights: [400] },
  { family: 'Archivo Black', weights: [400] },
  { family: 'Barlow Condensed', weights: [500, 600, 700, 800, 900], italic: true },
  { family: 'Bricolage Grotesque', weights: [400, 500, 600, 700, 800] },
  { family: 'Fraunces', weights: [400, 500, 600, 700, 800, 900], italic: true },
  { family: 'DM Serif Display', weights: [400], italic: true },
];

function stylesheetUrl() {
  const families = [];

  for (const font of FONTS) {
    const name = font.family.replace(/ /g, '+');

    if (font.italic) {
      const axes = [];

      for (const weight of font.weights) {
        axes.push('0,' + weight);
      }

      for (const weight of font.weights) {
        axes.push('1,' + weight);
      }

      families.push('family=' + name + ':ital,wght@' + axes.join(';'));
    } else {
      families.push('family=' + name + ':wght@' + font.weights.join(';'));
    }
  }

  return 'https://fonts.googleapis.com/css2?' + families.join('&') + '&display=block';
}

let stylesheetPromise = null;

function ensureStylesheet() {
  if (stylesheetPromise) {
    return stylesheetPromise;
  }

  stylesheetPromise = new Promise(resolve => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = stylesheetUrl();
    link.onload = resolve;
    link.onerror = resolve;
    document.head.appendChild(link);
  });

  return stylesheetPromise;
}

/* Garante que todas as fontes usadas pelo modelo estão prontas antes do desenho. */
export function loadFontStylesheet() {
  return ensureStylesheet();
}

/*
 * Pré-carga na página de compartilhar: baixa o CSS e os arquivos das fontes
 * de cada par, para o gerador abrir já com o texto desenhado.
 */
export async function preloadFonts() {
  await ensureStylesheet();

  const specs = new Set();

  for (const pair of FONT_PAIRS) {
    for (const font of [pair.title, pair.support]) {
      const style = font.italic ? 'italic ' : '';
      specs.add(style + font.weight + ' 40px "' + font.font + '"');
    }
  }

  const loads = [];

  for (const spec of specs) {
    loads.push(document.fonts.load(spec).catch(() => null));
  }

  await Promise.all(loads);
}

export async function loadTemplateFonts(config) {
  await ensureStylesheet();

  const specs = new Set();

  for (const element of config.elements || []) {
    if (element.type !== 'text') {
      continue;
    }

    const style = element.italic ? 'italic ' : '';
    specs.add(style + element.weight + ' 40px "' + element.font + '"');
  }

  const loads = [];

  for (const spec of specs) {
    loads.push(document.fonts.load(spec).catch(() => null));
  }

  await Promise.all(loads);
}
